import Garuantee from "../components/garuantee/Garuantee";
import Layout from "../layout/Layout";

const GaruanteePage = () => {
  return (
    <Layout>
      <Garuantee />
    </Layout>
  );
};

export default GaruanteePage;
